import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormCard } from './FormCard';
import { Dialog } from 'primereact/dialog';



export const ModalCard = (props) => {
    const {
        modalCard, toggleCard, modalTitleCard, loading, method, typeCard = "typeCard", checkbox, check,
        handleCheckboxChange, handleInputChangeT, id_departament, departament, handleSectionUser,
        section, changeTree, treeviewRef, tree, onRenderItem, flag, processes, saveCardCode,
        handleListSectionsCard, card_code, handleInputChange, checkSection, handleCheckChange,
        listDepartament, handleSelectValues, formUser, id_departaments, listDepa, handleListCedula, url_helen,
        name_user, generateCardCode, validationsCard, savedCardCode, handleCardCodeChange,
        handleToggleAllSections

    } = props;
    console.log("🚀 ~ ModalCard ~ name_user:", name_user)

    return (
        <Dialog
            //header={"Accesos del usuario"}
            visible={modalCard}
            onHide={toggleCard}
            footer={
                <>
                    <Button
                        size="sm"
                        color="secondary"
                        onClick={() => saveCardCode()}
                        className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""} disabled={loading}>
                        {"Guardar"}
                    </Button>

                    <Button

                        size="sm"
                        color="danger"
                        onClick={toggleCard}
                    >
                        {"Cancelar"}
                    </Button>
                </>
            }

            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-credit-card"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Accesos del usuario
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-2`}
            closable={false}









        >
            {
                typeCard === "typeCard"
                    ?
                    <FormCard button='Guardar' {...{
                        toggleCard, loading, modalCard, modalTitleCard,
                        handleCheckboxChange, method, typeCard, checkbox, check, handleInputChangeT,
                        id_departament, departament, handleSectionUser, section, changeTree, treeviewRef, tree,
                        onRenderItem, processes, methodAction: saveCardCode, handleListSectionsCard,
                        card_code, handleInputChange, checkSection, handleCheckChange, listDepartament,
                        handleSelectValues, formUser, id_departaments, listDepa, url_helen, name_user, generateCardCode,
                        validationsCard, savedCardCode, handleToggleAllSections, handleCardCodeChange
                    }} />
                    : " "
            }

        </Dialog>



    )
}
